<template>
  <el-dialog
    title="选择专业筛选条件"
    :visible.sync="dialogVisible"
    append-to-body
    top="2vh"
    :show-close=show_close 
    width="80%">
    <div style="width: 100%;display: flex;align-items: center;">
      <el-form inline label-width="100px" :style="$parent.batch=='本科批'?'width:34%;':'width: 69%;'">
        <el-item style="line-height: 38px;width: 100%;display: flex;">
          普通专业筛选：
        </el-item>
        <el-form-item label="学科门类：">
          <el-select
            v-model="form.subject"
            @change="subjectChange"
            size="small"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in xueke"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级学科：">
          <el-select
            v-model="form.majors"
            @change="majorsChange"
            size="small"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in yiji"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业名称：">
          <el-input
            placeholder="请输入专业名称"
            clearable
            v-model="form.major_name"
            @keyup.enter.native="selectMajorList()"
            size="small"
          ></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="success" size="small" @click="selectMajorList()"
            >检索</el-button
          >
        </el-form-item>
      
    </el-form>
    
    <el-form inline label-width="100px" v-if="$parent.detail.batch=='本科批'" style="width: 35%;">
      <el-item style="line-height: 38px;width: 100%;display: flex;">
        高职专业筛选：
      </el-item>
      <el-form-item label="学科门类：">
        <el-select
          v-model="gzform.subject"
          @change="subjectGzChange"
          size="small"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in gzxueke"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级学科：">
        <el-select
          v-model="gzform.majors"
          @change="majorsGzChange"
          size="small"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in gzyiji"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专业名称：">
        <el-input
          placeholder="请输入专业名称"
          clearable
          v-model="gzform.major_name"
          @keyup.enter.native="selectGaozhiList()"
          size="small"
        ></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button type="success" size="small" @click="selectGaozhiList()"
          >检索</el-button
        >
      </el-form-item>
    </el-form>
    <el-form inline label-width="100px"  style="width: 27%;margin-left: auto;">
      <div>
        <!--其他专业-->
        <el-item style="line-height: 38px;width: 100%;display: flex;">
          特殊专业操作：
        </el-item>
        
        <el-form-item >
          <el-button type="success" style="margin-left:10px;" size="small" @click="baocunTeshu()">保存</el-button>
        </el-form-item>
      <!--其他专业-->

      </div>
    </el-form>
    </div>
    
    <div style="width: 100%;display: flex;align-items: center;">
      <div class="checkbox" :style="$parent.batch=='本科批'?'width:34%;':'width: 69%;'">
        <div style="width: 95%; margin: 0 auto; height: 98%; margin-top: 1%">
          <el-checkbox
            :indeterminate="indeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选普通专业</el-checkbox
          >
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              v-for="item in list"
              :label="item.major_name"
              :key="item.major_name"
              >{{ item.major_name }}-{{ item.major_code }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="checkbox"  v-if="$parent.batch=='本科批'" style="width: 35%;">
        <div style="width: 95%; margin: 0 auto; height: 98%; margin-top: 1%">
          <el-checkbox
            :indeterminate="gaozhiindeterminate"
            v-model="gaozhicheck"
            @change="handleCheckAllChangeA"
            >全选高职</el-checkbox
          >
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="gaozhiSelect"
            @change="handleCheckedCitiesChangeA"
          >
            <el-checkbox
              v-for="item in gaozhiArr"
              :label="item.major_name"
              :key="item.major_name"
              style="width: 40%;"
              >{{ item.major_name }}-{{ item.major_code }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="checkbox ass" style="width: 27%;margin-left: auto;">
        <div style="width: 95%; margin: 0 auto; height: 98%; margin-top: 1%">
              <el-checkbox
                :indeterminate="indeterminates"
                v-model="checkAlls"
                @change="handleCheckAllChanges">
                全选特殊专业
              </el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="teshuSelect"
                @change="handleCheckedCitiesChanges">
                <el-checkbox
                  v-for="item in teshuArr"
                  :label="item"
                  :key="item">
                  {{ item }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
      </div>
    </div>

    <div
      style="width: 100%; display: flex; align-items: center; margin-top: 20px">
      <el-button type="primary" size="small" @click="addClick">添加</el-button>
      <el-button type="warning" size="small" @click="deleHnah">
        移除选中专业
      </el-button>
      <el-button type="danger" size="small" @click="allDele">
        全部移除
      </el-button>
      <div style="font-size: 14px; margin-left: 20px">
        选中{{ checkList.length }}个
      </div>
      <div
        style="color: #ffa534 !important; font-size: 14px; margin-left: 20px">
        警告：满足筛选条件的专业过多,只显示前200个
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="checkList"
      v-loading="loading"
      tooltip-effect="dark"
      style="width: 100%; max-height: 40vh; overflow-y: scroll"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="dele(scope.$index)">
            删除
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="专业代码">
        <template slot-scope="scope">
          {{ scope.row.major_code }}
        </template>
      </el-table-column>
      <el-table-column label="专业名称">
        <template slot-scope="scope">
          {{ scope.row.major_name }}
        </template>
      </el-table-column>
      <el-table-column label="所属一级学科">
        <template slot-scope="scope">
          {{ scope.row.majors }}
        </template>
      </el-table-column>
      <el-table-column label="所属学科门类">
        <template slot-scope="scope">
          {{ scope.row.subject }}
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="guanbi()">关 闭</el-button>
      <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import {

  selectMajorForm,
  selectOneMajor,
  selectMajorList,
  screenFind,
  screenFindSave,
} from "@/api/admin/volunteer/selectMajor.js";
import { 
  Mojor_teshuList,
  selectGzMajorForm,
  selectGzOneMajor,
  selectGaozhiList,
} from "@/api/gw/major.js";
export default {
  data() {
    return {
      show_close:false,
      aspid: "",
      dialogVisible: false,
      xueke: [], //学科门类
      yiji: [], //一级学科
      gzxueke: [], //高职学科门类
      gzyiji: [], //高职一级学科
      list: [], //专业列表
      form: {
        subject: "全部", //学科门类
        majors: "全部", //一级学科
        major_name: "", //专业名称
      },
      gzform: {
        subject: "全部", //学科门类
        majors: "全部", //一级学科
        major_name: "", //专业名称
      },
      loading: false,

      checkAll: false, //全选
      checkedCities: [], //选中的内容
      indeterminate: true,

      checkList: [], //选中的专业
      loading: false,

      multipleSelection: [],

      teshuArr: [], //特殊专业筛选
      teshuSelect:null,
      gaozhicheck: false, //全选
      gaozhiArr: [], //高职专业筛选
      gaozhiSelect:null,
      gaozhiindeterminate: true,
      indeterminates:true,//全选
      checkAlls:false,

    };
  },
  mounted() {
  },
  methods: {
    baocunTeshu(){
      screenFindSave({
        aspid: this.aspid,
        name: "major_teshu_screen",
        value: JSON.stringify(this.teshuSelect),
      }).then(()=>{
        this.$notify({
            title: "成功",
            message: "",
            type: "success",
          });
      })
    },
    show() {
      console.log("1");
      this.$nextTick(() => {
        this.dialogVisible = true;
        //这里先获取筛选的数据
        this.aspid = this.$parent.detail.volunteer_id;
        this.screenFind(); //获取已经选择筛选的列表
        this.selectMajorList(); //专业列表
        this.selectMajorForm(); //学科门类检索
        if(this.$parent.batch=='本科批')this.selectGzMajorForm(); //学科门类检索
        if(this.$parent.batch=='本科批')this.selectGaozhiList();
        this.Mojor_teshuList();
      });
    },
    Mojor_teshuList() {
      Mojor_teshuList({}).then((res) => {
        this.teshuArr = res.data;
        if(this.teshuSelect==null){
          this.teshuSelect = res.data;
        }
      });
    },
    handleCheckAllChangeA(val) {
      let arr = [];
      this.gaozhiArr.forEach((r) => {
        arr.push(r.major_name);
      });
      this.gaozhiSelect = val ? arr : [];
      this.gaozhiindeterminate = false;
    },
    screenFind() {
      this.loading = true;
      screenFind({
        aspid: this.aspid,
      })
        .then((res) => {
          console.log("已经选择的数据", res.data);
          if (res.data && res.data.major_screen) {
            let checkList = JSON.parse(res.data.major_screen);
            this.checkList = checkList;
          } else {
            this.checkList = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guanbi() {
      screenFindSave({
        aspid: this.aspid,
        name: "major_teshu_screen",
        value: JSON.stringify(this.teshuSelect),
      }).then(()=>{
        // this.$notify({
        //     title: "成功",
        //     message: "",
        //     type: "success",
        //   });
          this.dialogVisible = false;
      })
      // this.$parent.getList();
      
      // screenFindSave({
      //   aspid: this.aspid,
      //   name: "major_teshu_screen",
      //   value: JSON.stringify(this.teshuSelect),
      // }).then(()=>{
      //     this.dialogVisible = false;
      // })
    },
    //添加
    addClick() {
      let checkedCities = [...this.checkedCities];
      let checkedGaozhis = [];
      if(this.$parent.batch=='本科批') checkedGaozhis = [...this.gaozhiSelect];
      console.log(this.$parent.batch);
      let checkList = [...this.checkList];
      if (checkedCities.length == 0 && (this.$parent.batch=='本科批'?checkedGaozhis.length == 0:true)) {
        this.$message.error("请选择专业");
        return;
      }
      let arr = [];
      this.list.forEach((r) => {
        checkedCities.forEach((j) => {
          if (r.major_name == j) {
            arr.push(r);
          }
        });
      });

      if(this.$parent.batch=='本科批')this.gaozhiArr.forEach((r) => {
        checkedGaozhis.forEach((j) => {
          if (r.major_name == j) {
            arr.push(r);
          }
        });
      });

      checkList = checkList.concat(arr);
      const result = checkList.reduce((accumulator, currentValue) => {
        if (
          !accumulator.some(
            (item) => item.major_name === currentValue.major_name
          )
        ) {
          accumulator.push(currentValue);
        }
        return accumulator;
      }, []);
      //添加走接口
      this.loading = true;
      screenFindSave({
        aspid: this.aspid,
        name: "major_screen",
        value: JSON.stringify(result),
      })
        .then(() => {
          this.$notify({
            title: "成功",
            message: "",
            type: "success",
          });
          this.screenFind();
        })
        .finally(() => {
          this.loading = true;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeForm() {},
    dele(index) {
      this.$confirm("确认从过滤条件中移除当前专业吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let list = [...this.checkList];
        list.splice(index, 1);
        this.loading = true;
        screenFindSave({
          aspid: this.aspid,
          name: "major_screen",
          value: JSON.stringify(list),
        })
          .then(() => {
            this.$notify({
              title: "成功",
              message: "",
              type: "success",
            });
            this.screenFind();
          })
          .finally(() => {
            this.loading = true;
          });
      });
    },
    deleHnah() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择要移除的专业");
        return;
      }
      this.$confirm("确认要移除选中的专业吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let result = this.checkList.filter(
          (item) =>
            !this.multipleSelection.some(
              (arrItem) => arrItem.major_name === item.major_name
            )
        );
        this.loading = true;
        screenFindSave({
          aspid: this.aspid,
          name: "major_screen",
          value: JSON.stringify(result),
        })
          .then(() => {
            this.$message.success("移除成功");
            this.screenFind();
          })
          .finally(() => {
            this.loading = true;
          });
      });
    },
    //全部移除
    allDele() {
      this.$confirm("确认移除所有专业吗?", "确认移除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        screenFindSave({
          aspid: this.aspid,
          name: "major_screen",
          value: "[]",
        })
          .then(() => {
            this.$notify({
              title: "成功",
              message: "",
              type: "success",
            });
            this.multipleSelection = [];
            this.screenFind();
          })
          .finally(() => {
            this.loading = true;
          });
      });
    },
    handleCheckAllChange(val) {
      let arr = [];
      this.list.forEach((r) => {
        arr.push(r.major_name);
      });
      this.checkedCities = val ? arr : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.list.length;
    },
    handleCheckAllChanges(val){
       let arr = [];
       this.teshuArr.forEach(r=>{
          arr.push(r);
       })
       this.teshuSelect = val ? arr : [];
       this.indeterminates = false;
    },
    handleCheckedCitiesChangeA(value){
      let checkedCount = value.length;
      this.gaozhicheck = checkedCount === this.gaozhiArr.length;
      this.gaozhiindeterminate =
        checkedCount > 0 && checkedCount < this.gaozhiArr.length;
    },
    handleCheckedCitiesChanges(value){
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.teshuArr.length;
      this.indeterminates =
        checkedCount > 0 && checkedCount < this.teshuArr.length;
    },
    //获取学科分类
    selectMajorForm() {
      selectMajorForm({
        cengci: this.$parent.detail.batch,
      }).then((res) => {
        res.data.unshift("全部");
        this.xueke = res.data;
      });
    },
    //学科门类检索
    subjectChange(e) {
      this.yiji = ["全部"];
      this.form.majors = "全部"; //一级学科
      this.form.major_name = ""; //专业名称
      this.selectMajorList();
      this.selectOneMajor();
    },//获取高职学科分类
    selectGzMajorForm() {
      selectGzMajorForm({
        cengci: '本科（职业教育）',
      }).then((res) => {
        res.data.unshift("全部");
        this.gzxueke = res.data;
      });
    },
    //学科高职门类检索
    subjectGzChange(e) {
      this.gzyiji = ["全部"];
      this.gzform.majors = "全部"; //一级学科
      this.gzform.major_name = ""; //专业名称
      this.selectGaozhiList();
      this.selectGzOneMajor();
    },
    selectGaozhiList(){
      let that = this;
      let form = { ...this.gzform };
      form["subject"] = form.subject == "全部" ? "" : form.subject;
      form["majors"] = form.majors == "全部" ? "" : form.majors;
      form["cengci"] = '本科（职业教育）';
      selectGaozhiList(form)
        .then((res) => {
          console.log("高职专业", res.data);
          if (Array.isArray(res.data)) {
              that.gaozhiArr = [...res.data]; // 使用展开运算符创建新数组
              if(that.gaozhiSelect == null){
                that.gaozhiSelect = [...res.data]; // 使用展开运算符创建新数组
              }
          } else {
              that.gaozhiArr = []; // 异常时回退为空数组
          }
        }).finally(() => {
          this.gaozhicheck = false; //全选
          this.gaozhiSelect = []; //选中的内容
          this.gaozhiindeterminate = true;
        });
    },
    selectMajorList() {
      this.loading = true;
      let form = { ...this.form };
      form["subject"] = form.subject == "全部" ? "" : form.subject;
      form["majors"] = form.majors == "全部" ? "" : form.majors;
      form["cengci"] = this.$parent.detail.batch;
      selectMajorList(form)
        .then((res) => {
          console.log("专业", res);
          this.list = res.data;
        })
        .finally(() => {
          this.checkAll = false; //全选
          this.checkedCities = []; //选中的内容
          this.indeterminate = true;
          this.loading = false;
        });
    },
    selectOneMajor() {
      let that = this;
      selectOneMajor({
        subject: that.form.subject,
        cengci: this.$parent.detail.batch,
      }).then((res) => {
        res.data.unshift("全部");
        that.yiji = res.data;
      });
    },
    selectGzOneMajor() {
      let that = this;
      selectGzOneMajor({
        subject: that.gzform.subject,
        cengci: '本科（职业教育）',
      }).then((res) => {
        res.data.unshift("全部");
        that.gzyiji = res.data;
      });
    },
    majorsChange() {
      this.selectMajorList();
    },
    majorsGzChange() {
      this.selectGaozhiList();
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  width: 100%;
  height: 160px;
  overflow-y: scroll;
  border: 1px solid #dee2e6 !important;
  border-radius: 5px;
}
.el-checkbox {
  width: 29%;
  margin-bottom: 10px;
}
.ass .el-checkbox {
  width: 40%!important;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/selectMajor.vue